import { CircularProgress } from '@mui/material'
import { useEffect, useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import { AuthService } from '../../../services/auth'
import { ErrorMessage } from '../../../store/Application/appActions'
import RestUtils from '../../../utils/restUtils'

type ImgLoaderProps = {
  src: string
  alt: string
  styles?: React.CSSProperties
}

const useStyles = makeStyles()(() => ({
  maxWidthImg: {
    maxWidth: '100%',
  },
}))

export const ImgLoader = (props: ImgLoaderProps) => {
  const { classes } = useStyles()

  const [img, setImg] = useState(undefined)
  const [error, setError] = useState(false)

  useEffect(() => {
    let cancelled = false

    const getImage = async () => {
      const accessToken = await AuthService.GetCurrent().GetAccessToken()

      if (cancelled) return

      try {
        const res = await RestUtils.request(
          'GET',
          props.src,
          null,
          false,
          false,
          null,
          null,
          accessToken,
        )

        // Component unmounted (or src changed) while the request was in
        // flight - discard the result instead of setting state / erroring.
        if (cancelled) return

        if (res.content) {
          setImg(res.content)
        }
      } catch (err) {
        if (cancelled) return

        ErrorMessage('image viewer', err['message'])
        setError(true)
        setImg(undefined)
      }
    }

    getImage()

    return () => {
      cancelled = true
    }
  }, [props.src])

  return (
    <div className="imgloader">
      {error && <div className="subtitle">Error loading the image</div>}
      {!error ? (
        !img ? (
          <CircularProgress />
        ) : (
          <img
            loading="lazy"
            src={`data:image/png;base64, ${img}`}
            alt={props.alt}
            className={classes.maxWidthImg}
            style={{ ...(props.styles || {}) }}
          />
        )
      ) : null}
    </div>
  )
}
